import { LegalLayout, LS, LUl } from "../components/launchx/LegalLayout";

export default function TermsAndConditions() {
  return (
    <LegalLayout title="Terms & Conditions" updated="26 September 2026" testid="terms-page">
      <p className="text-sm text-slate-600 leading-relaxed">
        These Terms &amp; Conditions ("Terms") govern your use of the LaunchX Academy website (launchxacademy.com) and your interaction with LaunchX Academy ("LaunchX Academy", "we", "us", or "our"), including enquiries, counselling, admissions, and participation in our training programs.
      </p>
      <p className="mt-3 text-sm text-slate-600 leading-relaxed">
        By using our website, submitting an enquiry, or enrolling in a program, you agree to these Terms. If you do not agree, please do not use the website or submit your information.
      </p>

      <LS n={1} title="Website Usage">
        <p>This website is provided for general information about LaunchX Academy and its programs. You agree to use the website lawfully and not to misuse it, attempt unauthorised access, interfere with its operation, or submit false, misleading, or fraudulent information.</p>
      </LS>

      <LS n={2} title="Course Information">
        <p>Course descriptions, curriculum, duration, fees, schedules, and other details published on this website are provided in good faith and may be updated from time to time. While we aim for accuracy, website content does not constitute a binding offer or contract.</p>
      </LS>

      <LS n={3} title="Enquiry and Counselling">
        <p>Submitting an enquiry or booking a counselling session is free of charge and does not create any obligation on either side. Submitting an enquiry is not an admission, does not reserve a seat, does not constitute a student contract, and does not involve any payment.</p>
      </LS>

      <LS n={4} title="Admission and Registration">
        <p>Admission to any LaunchX Academy program is confirmed only after completion of the applicable admission process, verification of details, and payment of the applicable course fee. Only authorised LaunchX Academy staff can confirm an admission.</p>
      </LS>

      <LS n={5} title="Course Fees">
        <p>The course fee displayed on the website is the current fee for the applicable program and may change for future batches. The fee applicable to your admission is the fee communicated and confirmed at the time of your admission.</p>
      </LS>

      <LS n={6} title="Payment Terms">
        <p>Payment methods, schedules, and any instalment options (if available) will be communicated during the admission process. Any refund or cancellation request is subject to the applicable admission/refund policy communicated at the time of admission.</p>
      </LS>

      <LS n={7} title="Batch Allocation">
        <p>Batches have limited seats. Batch allocation is subject to availability at the time of admission. We may offer an alternative batch timing where a preferred batch is full or rescheduled.</p>
      </LS>

      <LS n={8} title="Attendance">
        <p>Students are expected to maintain regular attendance to benefit fully from the program. Certification, where offered, may be subject to minimum attendance, assignment completion, and assessment requirements as communicated during the program.</p>
      </LS>

      <LS n={9} title="Course Duration">
        <p>The program duration published on the website (for example, 45 days) refers to the scheduled classroom training period. Timelines for completing assignments or the final project may be communicated separately by the academy.</p>
      </LS>

      <LS n={10} title="Course Content and Updates">
        <p>Online business platforms, tools, and advertising products change frequently. LaunchX Academy may update, substitute, or modify curriculum topics, tools, or platforms to keep the program current, without changing the overall scope and intent of the program.</p>
      </LS>

      <LS n={11} title="Student Responsibilities">
        <p>Students are responsible for their own learning, participation, assignments, and projects, and for complying with applicable laws and the terms of any third-party platforms they use. Any live business activity a student chooses to undertake (including advertising spend, inventory, registrations, or tool subscriptions) is the student's own responsibility and expense unless specifically stated otherwise.</p>
      </LS>

      <LS n={12} title="Intellectual Property">
        <p>All LaunchX Academy training materials, workbooks, templates, calculators, frameworks, and content are the intellectual property of LaunchX Academy and are provided for the personal learning use of enrolled students only. They may not be copied, resold, redistributed, or used for commercial training purposes without written permission.</p>
      </LS>

      <LS n={13} title="Website Content">
        <p>All text, design, logos, graphics, and other content on this website belong to LaunchX Academy or its licensors and may not be reproduced without permission. Trademarks of third-party platforms mentioned on this website (such as Shopify, Meta, Google, Amazon, or Flipkart) belong to their respective owners; LaunchX Academy is an independent training academy and is not officially endorsed by these companies.</p>
      </LS>

      <LS n={14} title="Third-Party Links and Services">
        <p>Our website may contain links to third-party websites or services (including WhatsApp). We are not responsible for the content, availability, security, or practices of third-party services. Your use of such services is governed by their own terms and policies.</p>
      </LS>

      <LS n={15} title="Promotional Communications">
        <p>Where you have provided your contact details and consent, LaunchX Academy may contact you by phone, SMS, WhatsApp, or email regarding your enquiry, counselling, admissions, and related services. You may opt out of promotional communications at any time by contacting us.</p>
      </LS>

      <LS n={16} title="No Guaranteed Outcomes">
        <p>LaunchX Academy provides practical education, tools, frameworks, and guided projects. We do not promise or guarantee income, employment, business success, placements, or specific financial results. Individual outcomes depend on the chosen business model, skills, effort, investment, market conditions, and quality of execution.</p>
      </LS>

      <LS n={17} title="Limitation of Liability">
        <p>To the maximum extent permitted by applicable law, LaunchX Academy shall not be liable for any indirect, incidental, or consequential loss, or for any loss of profit, revenue, data, or opportunity arising from the use of this website or participation in its programs. Our aggregate liability, where applicable, shall not exceed the course fee actually paid by you for the relevant program.</p>
      </LS>

      <LS n={18} title="Changes to Services">
        <p>We may modify, suspend, or discontinue any program, batch, or service where reasonably necessary (for example, due to operational or regulatory reasons). In such cases, affected students will be informed and offered reasonable alternatives.</p>
      </LS>

      <LS n={19} title="Changes to These Terms">
        <p>We may update these Terms from time to time. The updated version will be published on this page with a revised "Last Updated" date. Continued use of the website or services after changes are published constitutes acceptance of the updated Terms.</p>
      </LS>

      <LS n={20} title="Governing Law and Jurisdiction">
        <p>These Terms are governed by the laws of India. Any dispute arising from or relating to these Terms, the website, or LaunchX Academy services shall be subject to the exclusive jurisdiction of the courts at Rampur, Uttar Pradesh, India.</p>
      </LS>

      <LS n={21} title="Contact Information">
        <p>For any questions regarding these Terms, you can contact us at:</p>
        <div className="bg-background border border-slate-200 rounded-xl p-5 text-sm text-navy space-y-1.5">
          <p className="font-display font-bold">LaunchX Academy</p>
          <p>Website: launchxacademy.com</p>
          <p>Email: academylaunchx@gmail.com</p>
          <p>Phone / WhatsApp: +91 97623 84018</p>
          <p>Address: Dayal Building, Old Mirza Hospital, Darakht Khinni, Near Hamid School, Rampur, U.P. 244901, India</p>
        </div>
      </LS>
    </LegalLayout>
  );
}
